import type { Dict } from './en';

/** Russian (partial; missing keys fall back to English). */
export const ru: Partial<Dict> = {
  'auto.typePlaceholder': 'Напишите от имени посетителя…',
  'auto.typeSend': 'Отправить',
  'auto.typedBy': 'написал {by}',
  'auto.operator': 'оператор',
  'common.close': "Закрыть",
  'maps.resizePanel': 'Потяните, чтобы изменить ширину панели (двойной клик — сброс)',
  'common.cancel': "Отмена",
  'maps.noRobotOnline': "Нет роботов в сети",
  'maps.pullFailed': "Не удалось загрузить",
  'maps.pulled': "Загружена «{name}»",
  'maps.pulling': "Загрузка…",
  'maps.pull': "Загрузить с робота",
  'maps.current': "текущая",
  'maps.robotMap': "Карта на роботе",
  'maps.listMaps': "Список карт",
  'maps.robot': "Робот",
  'maps.pullTitle': "Загрузить карту с робота",
  'fab.wheelsReleased': "Колёса отпущены",
  'fab.switchFor': "Ручной режим для {name}",
  'fab.chipEstop': "Аварийная",
  'fab.chipIdle': "Свободен",
  'fab.chipLocking': "Блокирую…",
  'fab.chipReleasing': "Отпускаю…",
  'fab.lockAll': "Заблокировать все колёса",
  'fab.noneOnline': "Нет роботов в сети",
  'fab.popHint': "Отпускает тормоза колёс, чтобы сотрудник мог передвинуть робота руками. Выключите, чтобы снова заблокировать колёса.",
  'fab.summaryN': "Роботов в ручном режиме: {n}",
  'fab.summaryOne': "{n} робот в ручном режиме",
  'fab.lockN': "Заблокировать колёса · роботов: {n}",
  'fab.handPushName': "Ручной режим · {name}",
  'fab.lockName': "Заблокировать колёса · {name}",
  'fab.charging': "Ручной режим · робот на зарядке",
  'fab.offline': "Ручной режим · робот не в сети",
  'fab.locking': "Блокирую колёса · {name}",
  'fab.releasingShort': "Отпускаю колёса…",
  'fab.lockingShort': "Блокирую колёса…",
  'fab.chargingShort': "Ручной режим · на зарядке",
  'fab.offlineShort': "Ручной режим · не в сети",
  'fab.releasing': "Отпускаю колёса · {name}",
  'hand.retry': "Повторить",
  'pull.keepOpen': "Большие сканы по Wi-Fi идут несколько минут; не закрывайте окно.",
  'pull.mb': "{a} МБ",
  'pull.mbOf': "{a} из {b} МБ",
  'pull.stage.working': "Выполняется…",
  'pull.stage.uploading': "Отправка на сервер",
  'pull.stage.downloading': "Робот собирает карту",
  'pull.stage.asking': "Запрос к роботу…",
  'pull.pullingName': "Загружаю «{name}»…",
  'pull.copies': "Скопирует «{name}» на сервер",
  'pull.replaces': "Заменит копию «{name}» на сервере",
  'pull.converts': "Превратит «{name}» в навигационную карту",
  'pull.selectOne': "Выберите карту для загрузки",
  'pull.waiting': "Ждём ответа робота",
  'pull.hint': "Карты U-SCAN создаёт приложение сканирования на роботе; при загрузке они превращаются в навигационную карту",
  'pull.today': "сегодня, {time}",
  'pull.modified': "изменена {when}",
  'pull.onServer': "уже на сервере",
  'pull.uscanError': "Не удалось прочитать карты U-SCAN: {error}",
  'pull.noUscanHint': "Отсканируйте помещение в приложении U-SCAN на роботе, затем обновите список.",
  'pull.noUscan': "На этом роботе нет карт U-SCAN",
  'pull.noSdk': "На этом роботе нет навигационных карт",
  'pull.mapsN': "карт: {n}",
  'pull.mapsOne': "{n} карта",
  'pull.scanningApp': "приложение сканирования",
  'pull.secSdk': "Навигация (SDK)",
  'pull.retry': "Повторить",
  'pull.refresh': "Обновить список карт",
  'pull.countOn': "{n} на {robot}",
  'pull.listingOn': "Запрашиваю карты у {robot}… сначала навигация, затем U-SCAN",
  'pull.listing': "загрузка…",
  'pull.pickRobot': "Выберите робота онлайн",
  'pull.robotOffline': "{robot} не в сети: список карт доступен только у робота онлайн",
  'pull.offline': "Робот не в сети",
  'pull.offlineShort': "офлайн",
  'pull.online': "онлайн",
  'clog.appHint': "Хвост лога приложения робота. Нажмите «Загрузить»: сервер запросит его у робота.",
  'clog.noLines': "(нет подходящих строк)",
  'clog.lines': "Строк",
  'clog.grep': "grep…",
  'clog.empty': "Записей нет",
  'clog.apiMissing': "Для этого журнала нужен более новый сервер",
  'clog.data': "Данные",
  'clog.args': "Аргументы",
  'clog.error': "ошибка",
  'clog.colArgs': "Аргументы / данные",
  'clog.colDuration': "Длит.",
  'clog.colResult': "Результат",
  'clog.colSource': "Источник",
  'clog.colName': "Команда / событие",
  'clog.colTime': "Время",
  'clog.load': "Загрузить",
  'clog.refresh': "Обновить",
  'clog.rowsN': "строк: {n}",
  'clog.nameFilter': "Фильтр по имени…",
  'clog.events': "События",
  'clog.cmds': "Команды",
  'clog.all': "Все",
  'clog.kind': "Тип",
  'clog.tab.app': "Лог приложения робота",
  'clog.tab.cmd': "Журнал команд",
  'clog.tab.events': "События",
  'clog.logs': "Журналы",
  'hist.deleteLive': "Идущий разговор нельзя удалить",
  'hist.deleteFailed': "Не удалось удалить разговор",
  'hist.deleted': "Разговор удалён",
  'hist.deleteConfirm': "Удалить этот разговор навсегда?",
  'hist.exportFailed': "Не удалось экспортировать",
  'hist.loadEarlier': "Загрузить более ранние сообщения",
  'hist.go': "OK",
  'hist.jump': "Перейти к",
  'hist.toolsN': "инструментов: {n}",
  'hist.turnsN': "реплик: {n}",
  'hist.session': "Разговор",
  'hist.more': "Показать ещё",
  'hist.empty': "Нет разговоров по этим условиям",
  'hist.apiMissing': "Для истории разговоров нужен более новый сервер",
  'hist.end.error': "ошибка",
  'hist.end.schedule': "окно расписания закрылось",
  'hist.end.estop': "аварийная остановка",
  'hist.end.ended': "завершён",
  'hist.end.battery': "низкий заряд",
  'hist.end.timeout': "тишина",
  'hist.end.stopped': "остановил оператор",
  'hist.live': "идёт",
  'hist.colPreview': "Первая реплика",
  'hist.colEnd': "Завершение",
  'hist.colTools': "Инстр.",
  'hist.colTurns': "Реплик",
  'hist.colDuration': "Длительность",
  'hist.colProfile': "Профиль",
  'hist.colRobot': "Робот",
  'hist.colWhen': "Когда",
  'hist.clearFilters': "Сбросить фильтры",
  'hist.to': "по",
  'hist.from': "с",
  'hist.allProfiles': "Все профили",
  'hist.allRobots': "Все роботы",
  'hist.profile': "Профиль",
  'hist.robot': "Робот",
  'hist.search': "Поиск по разговорам…",
  'hist.countN': "разговоров: {n}",
  'hist.linkTitle': "Просмотреть прошлые разговоры этого робота в автономии",
  'hist.link': "История разговоров",
  'hist.tabHistory': "История",
  'hist.tabProfiles': "Профили",
  'hist.title': "История автономии",
  'facing.warn': "Точек без направления: {n}",
  'facing.flipTitle': "Развернуть на 180° (для точки зарядки: Cruzr стыкуется задом, контакты сзади)",
  'facing.lookHint': "Кликните на карте, куда должна смотреть точка «{name}»",
  'facing.lookTitle': "Затем кликните на карте, где стоит человек или экспонат: точка повернётся туда",
  'facing.look': "Смотреть сюда",
  'facing.count': "{n} без направления",
  'facing.unsetHint': "робот приедет и будет смотреть куда попало; потяните стрелку, введите градусы или нажмите «Смотреть сюда»",
  'facing.unsetShort': "нет направления",
  'facing.unset': "направление не задано",
  'mapRobots.toggle': "Показать / скрыть подробности",
  'mapRobots.notLocatedHint': "робот не знает, где он на этой карте",
  'mapRobots.chipOtherMap': "карта {name}",
  'mapRobots.chipCharging': "на зарядке",
  'auto.state.idle': "ожидание",
  'auto.state.paused': "пауза",
  'auto.state.moving': "едет",
  'auto.state.speaking': "говорит",
  'auto.state.thinking': "думает",
  'auto.state.listening': "слушает",
  'hand.whyUnknown': "неизвестная ошибка",
  'hand.failReleaseSilent': "Не удалось освободить колёса · {name} не ответил",
  'hand.failLockSilent': "Не удалось заблокировать колёса · {name} не ответил — нажмите «Стоп» или аварийную кнопку на роботе",
  'hand.failRelease': "Не удалось освободить колёса · {name}: {why}",
  'hand.failLock': "Не удалось заблокировать колёса · {name}: {why} — нажмите «Стоп» или аварийную кнопку на роботе",
  'hand.whyCharging': "робот на зарядке",
  'hand.whyEstop': "нажата аварийная остановка",
  'hand.whyUnsupported': "приложение робота это пока не поддерживает",
  'mode.stopTitle': "Остановить текущую задачу",
  'mode.stopShort': "Стоп",
  'mode.exitHandPush': "Выйти из ручного режима: заблокировать колёса",
  'mode.lockShort': "Заблокировать",
  'mode.task': "Задача: {task}",
  'mode.navTo': "Навигация → {point}",
  'mode.navigation': "Навигация",
  'mode.tour': "Тур",
  'mode.autonomy': "Автономия",
  'mode.chargeFailed': "Не доехал до зарядки",
  'mode.goingCharge': "Едет на зарядку",
  'mode.charging': "На зарядке",
  'mode.stuckFailed': "Застрял · нужна помощь",
  'mode.stuck': "Застрял",
  'mode.handPush': "Ручной режим",
  'mode.estopHint': "Отпустите красную кнопку на спине робота",
  'mode.estop': "Аварийная остановка",
  'mode.normal': "Обычный",
  'cal.mirrorNotSupported': "Сервер пока не принимает cameraMirrored; зеркальность исправляется только в этой консоли.",
  'cal.pushMirror': "Также сообщить роботу (cameraMirrored), чтобы он сам исправлял направление",
  'cal.mirrorUnclear': "зеркальность неясна (встаньте левее)",
  'cal.mirrorNo': "лево/право верно",
  'cal.mirrorYes': "лево/право ЗЕРКАЛЬНО",
  'cal.camScale': "дистанция × {s}",
  'cal.camSkipped': "не проверялась",
  'cal.camera': "Камера",
  'cal.skip': "Пропустить",
  'cal.camTooFew': "Кадров с лицом только {n}; встаньте лицом к роботу и запишите снова.",
  'cal.camGot': "кадров с лицом: {n} · медиана {d} м, {b}° (+ = слева)",
  'cal.camStarting': "Открываю камеру… распознавание людей начнётся, когда робот начнёт её транслировать.",
  'cal.camNoSupport': "Этот робот не присылает людей по камере (старое приложение).",
  'cal.step.camera': "Необязательно: встаньте в 1 м перед роботом, примерно на 30 см ЛЕВЕЕ (слева от робота), лицом к нему (камера видит лица). Запишите 10 с. Так проверяется масштаб дистанции камеры и не перепутаны ли лево/право.",
  'cal.short.camera': "Камера 1 м (необяз.)",
  'sens.srcPeopleOff': "Лица с камеры · выкл. (камера не открыта)",
  'sens.srcPeople': "Лица с камеры · сейчас {n} · обзор {fov}°",
  'sens.colSource': "Источник",
  'sens.camWatching': "Камера открыта",
  'sens.camOpen': "Открыть камеру",
  'sens.camOffTitle': "Люди по камере: выключено",
  'sens.camHint': "Люди по камере работают, когда открыта камера робота",
  'sens.camLayerTitle': "Лица с камеры на голове (анфас, ~0.4–2.5 м) и поле зрения камеры",
  'sens.capPeople': "людей: {p} · приближ.: {n} · ближайший {d}",
  'sens.src.fused': "камера + глубина",
  'sens.src.camera': "камера",
  'sens.src.depth': "глубина",
  'sens.person': "Человек",
  'cal.reset': "Калибровка удалена",
  'cal.resetConfirm': "Удалить калибровку датчиков этого робота?",
  'cal.resetBtn': "Сбросить",
  'cal.current': "Текущая: {at} · порядок {order} · масштаб ×{scale}",
  'cal.savedLocal': "Калибровка сохранена в этом браузере (сервер пока её не хранит)",
  'cal.savedServer': "Калибровка сохранена для этого робота",
  'cal.save': "Сохранить калибровку",
  'cal.again': "Начать заново",
  'cal.ignoreNote': "Значения мерцания (засчитываются только при 4 из 5): {list}",
  'cal.noise': "Шум в пустоте по секторам",
  'cal.scale': "Масштаб дистанции",
  'cal.unclear': "неясно (оставлен по умолчанию)",
  'cal.rtl': "справа → налево (обратный)",
  'cal.ltr': "слева → направо",
  'cal.order': "Порядок секторов",
  'cal.finish': "Готово",
  'cal.next': "Далее",
  'cal.redo': "Записать заново",
  'cal.start': "Записать 10 с",
  'cal.back': "Назад",
  'cal.noData': "Нет свежих данных глубины от робота.",
  'cal.tooFew': "Слишком мало кадров; проверьте, что робот присылает данные глубины, и запишите снова.",
  'cal.nearShare': "Близкие значения по секторам",
  'cal.got': "Записано кадров: {n} · доля «близких» значений по секторам:",
  'cal.recording': "Запись… {s} с · кадров: {n}",
  'cal.passive': "Робот не двигается; записываются только данные глубины, которые он и так присылает.",
  'cal.step.right': "Теперь в 0.5 м спереди, у самого ПРАВОГО края (справа от робота). Запишите 10 с.",
  'cal.step.left': "Теперь в 0.5 м спереди, у самого ЛЕВОГО края обзора (слева от робота). Запишите 10 с.",
  'cal.step.centre': "Встаньте (или поставьте коробку) в 0.5 м перед роботом по центру. Не двигайтесь и запишите 10 с.",
  'cal.step.empty': "Освободите пространство перед роботом: ничего ближе 1.5 м (люди отходят в сторону). Затем запишите 10 с. Значения, мерцающие в пустоте, запоминаются как шум каждого сектора.",
  'cal.short.right': "0.5 м справа",
  'cal.short.left': "0.5 м слева",
  'cal.short.centre': "0.5 м по центру",
  'cal.short.empty': "Пусто",
  'cal.steps': "Шаги",
  'cal.notCalibrated': "не откалиброван",
  'cal.button': "Калибровка",
  'cal.title': "Калибровка датчиков",
  'sens.far': "далеко",
  'sens.chipLow': "Неуверенно",
  'sens.chipNoisy': "Шум",
  'sens.rawFilteredTitle': "Последнее сырое значение | отфильтрованное (см): медиана согласных из последних 5",
  'sens.colRawFiltered': "Сыр. | фильтр",
  'sens.lgClear': "≥ {d} = свободно",
  'sens.ageMin': "{m} мин назад",
  'sens.ageNow': "{s} с назад",
  'sens.ageS': "{s} с назад",
  'sens.alApproach': "Что-то приближается",
  'sens.alApproachDesc': "{id} · {d} {side} · {v} м/с · контакт через ≈{ttc} с",
  'sens.alCliff': "Обрыв · движение заблокировано",
  'sens.alCliffDesc': "Событие cliff из SDK (да/нет, без положения) · ROS остановил робота",
  'sens.alEstop': "Нажата аварийная остановка",
  'sens.alEstopDesc': "Отпустите кнопку на спине робота, чтобы снова ехать",
  'sens.alInside': "Опасное сближение · ближе {d}",
  'sens.alNone': "Нет предупреждений",
  'sens.alNoneDesc': "Ничего не приближается ближе {d}",
  'sens.alObstacle': "Событие obstacle из SDK",
  'sens.alObstacleDesc': "Навигация сообщает о препятствии впереди · ROS остановил движение",
  'sens.alSectorNd': "Сектор глубины {n} · нет данных",
  'sens.alSectorNdDesc': "Сектор возвращает 0 · вероятно, блик или вне диапазона",
  'sens.alSkin': "Касание e-skin · {z}",
  'sens.alSkinDesc': "Кто-то касается руки робота",
  'sens.alTooClose': "Слишком близко",
  'sens.alTooCloseDesc': "Что-то в {d} перед роботом",
  'sens.alertAt': "Предупреждать ближе",
  'sens.alerts': "Предупреждения",
  'sens.blindRear': "нет данных о дистанции (только навигация робота)",
  'sens.blindSide': "нет данных о дистанции",
  'sens.camSoonTitle': "Люди с камеры — скоро (на сервере пока нет детекций камеры)",
  'sens.capCharging': "Зарядка · датчики в покое",
  'sens.capCliff': "Обрыв · движение заблокировано",
  'sens.capNoSensors': "Нет данных датчиков",
  'sens.capStale': "Данные глубины устарели",
  'sens.capSummary': "{n} приближ. · ближайшее {d}",
  'sens.chargingDesc': "Отслеживание на паузе · данные глубины приходят ~1 Гц",
  'sens.chipClear': "Свободно",
  'sens.chipNoData': "Нет данных",
  'sens.clear': "свободно",
  'sens.clearBeyond': "дальше свободно",
  'sens.cliff': "Обрыв",
  'sens.cliffBadge': "Обрыв · SDK не даёт положения",
  'sens.colBearing': "Азимут",
  'sens.colDist': "Дист.",
  'sens.colHistory': "60 с",
  'sens.colRaw': "Сырое",
  'sens.colSector': "Сектор",
  'sens.colTrend': "Тренд",
  'sens.depthOnly': "глубина",
  'sens.details': "Подробности датчиков",
  'sens.eskin': "E-skin",
  'sens.estop': "Аварийная кнопка",
  'sens.frontLabel': "ВПЕРЁД · датчик глубины 72°",
  'sens.idleShort': "покой",
  'lidar.layer': 'Лидар 360°',
  'lidar.layerTitle': 'Показывать, что видит лидар робота, в реальном времени (стены точками, движущиеся объекты со следом)',
  'lidar.max': "Макс",
  'lidar.maxTitle': "Подогнать под самую дальнюю точку лидара",
  'lidar.zoomIn': "Ближе",
  'lidar.zoomOut': "Дальше",
  'lidar.zoomHint': "Колесо мыши над радаром меняет масштаб",
  'lidar.range': 'Дальность',
  'lidar.badge.live': 'LIVE {hz}',
  'lidar.badge.off': 'выключен',
  'lidar.badge.connecting': 'подключение…',
  'lidar.badge.nodata': 'нет данных',
  'lidar.badge.moving': 'робот едет',
  'lidar.card': 'Лидар в реальном времени',
  'lidar.switchTitle': 'Передавать лидар этого робота на сайт',
  'lidar.cardNote': 'Робот передаёт данные лидара, только пока этот переключатель включён и у кого-то открыт радар. Выключение останавливает поток для всех, кто смотрит этого робота.',
  'lidar.rate': 'Частота',
  'lidar.delay': 'Задержка',
  'lidar.watching': 'Смотрят',
  'lidar.status.off': 'Выключен: ничего не передаётся, на радаре только остальные слои.',
  'lidar.status.connecting': 'Ждём первый скан…',
  'lidar.status.live': 'Стены точками, движущиеся объекты — цветные точки со следом.',
  'lidar.status.moving': 'Робот едет: видны только стены, движущиеся объекты определяются, пока он стоит.',
  'lidar.status.nodata': 'Нет данных лидара: робот не в сети, старое приложение или лидар молчит.',
  'lidar.moving': 'Движущиеся объекты',
  'lidar.movingNote': '{n} · лидар',
  'lidar.colMotion': 'Движение',
  'lidar.approaching': 'приближается',
  'lidar.receding': 'уходит',
  'lidar.stopped': 'стоит {s} с',
  'lidar.noObjects': 'Вокруг робота ничего не движется.',
  'lidar.caption': "Лидар · ближе всего {d}",
  'lidar.captionNone': "Лидар · ничего не видно",
  'lidar.lgPoints': 'точки лидара (стены, мебель)',
  'lidar.lgTrail': 'след за 2 с',
  'lidar.toggle': 'Лидар',
  'lidar.toggleTitle': 'Лидар на мини-радаре',
  'site.label': "Площадка",
  'site.tabs': "Площадки",
  'site.robotSite': "Площадка робота",
  'site.none': "Без площадки",
  'site.noneShort': "Без площадки",
  'site.manage': "Площадки…",
  'site.manageShort': "Площадки…",
  'site.change': "Сменить площадку робота",
  'site.moveTo': "Перенести на площадку…",
  'site.moved': "{n} роб. → {site}",
  'site.movedNone': "{n} роб. теперь без площадки",
  'site.title': "Площадки",
  'site.oneSiteNote': "Робот всегда на одной площадке. Планшет, привязанный к площадке (Admin → Kiosk accounts), показывает только её роботов.",
  'site.name': "Название",
  'site.color': "Цвет",
  'site.robotsN': "{n} роб.",
  'site.edit': "Изменить {name}",
  'site.delete': "Удалить {name}",
  'site.deleteConfirm': "Удалить площадку «{name}»? Её роботы ({n}) останутся, но без площадки.",
  'site.empty': "Площадок пока нет.",
  'site.new': "Новая площадка",
  'site.newPlaceholder': "Например: Самарканд",
  'site.add': "Добавить",
  'site.allGroups': "Все группы",
  'site.sectionCount': "{n} роботов",
  'site.sectionOnline': "{n} в сети",
  'site.onlyThis': "Только {site}",
  'site.allFrom': "Все из «{site}» · {n}",
  'guard.barrier': "Сигнализация · {d}",
  'guard.barrierOff': "охрана выкл.",
  'guard.lgBarrier': "граница сигнализации (от корпуса)",
  'sens.lCamera': "Люди по камере",
  'sens.lDepth': "Веер глубины",
  'sens.lPresence': "Присутствие",
  'sens.lTracks': "Объекты",
  'sens.layers': "Слои",
  'sens.lblApproach': "↓ приближается {v} м/с · {ttc} с",
  'sens.lblAway': "↑ удаляется {v} м/с",
  'sens.lblStatic': "· на месте",
  'sens.legend': "Легенда",
  'sens.lgAlertRing': "граница предупреждения",
  'sens.lgHuman': "human_detect 1.3 м (без направления)",
  'sens.lgNoData': "нет данных о дистанции",
  'sens.no': "нет",
  'sens.noDirection': "без направления",
  'sens.noPose': "нет позы",
  'sens.noSensorsDesc': "Робот не присылает status.sensors (старое приложение или эмулятор)",
  'sens.noTracks': "Впереди ничего уверенно не обнаружено",
  'sens.noTracksStale': "Нет свежих данных глубины",
  'sens.object': "Объект",
  'sens.obstacle': "Препятствие",
  'sens.onChange': "при изменении",
  'sens.onEvent': "по событию",
  'sens.options': "Настройки радара",
  'sens.pressed': "НАЖАТА",
  'sens.radar': "Радар близости",
  'sens.released': "отпущена",
  'sens.robotViews': "Разделы робота",
  'sens.safetyEvents': "События безопасности",
  'sens.sectorsNote': "Сырые значения в см от робота (грубые, мерцают между кадрами). Сектор учитывается, только если 3 из последних 5 согласны; бледный = низкая уверенность. ≥ 95 см = далеко. Сзади и по бокам: нет данных о дистанции (только навигация робота).",
  'sens.sectorsTitle': "Глубина спереди · 6 секторов",
  'sens.sideF': "спереди",
  'sens.sideL': "спереди слева",
  'sens.sideR': "спереди справа",
  'sens.sources': "Источники данных",
  'sens.srcCliff': "Обрыв (да/нет) · {s}",
  'sens.srcDepth': "Сводка глубины · грубая (шаг ~15 см), 1 Гц",
  'sens.srcHuman': "Присутствие ≤ 1.3 м · {s} · без направления",
  'sens.srcObstacle': "Препятствие (ROS) · {s}",
  'sens.srcSkin': "Зоны касания рук · касаний: {n}",
  'sens.staleDesc': "Последнее значение глубины {age} · веер заштрихован, отслеживания нет",
  'sens.tabDrive': "Управление",
  'sens.tabSensors': "Датчики",
  'sens.toolbarNote': "только передний веер · тренд по замерам 1 Гц",
  'sens.tracked': "Отслеживаемые объекты",
  'sens.trackedNote': "{n} · глубина + камера",
  'sens.trend.approaching': "↓ ближе",
  'sens.trend.receding': "↑ дальше",
  'sens.trend.static': "· на месте",
  'sens.units': "Единицы",
  'sens.yes': "ДА",
  'sens.yesAhead': "ДА · впереди",
  'sens.state.normal': "Впереди свободно",
  'sens.state.approaching': "Кто-то приближается",
  'sens.state.tooClose': "Слишком близко",
  'sens.state.cliff': "Обрыв",
  'sens.state.nodata': "Нет данных датчиков",
  'sens.state.charging': "Зарядка · датчики в покое",
  'sens.radarToggle': "Радар",
  'sens.radarToggleTitle': "Показывать мини-радар поверх камеры",
  'sens.openSensors': "Открыть страницу датчиков",
  'maps.layerSensors': "Датчики",
  'charge.allBusy': "Все зарядки заняты — попробуйте позже",
  'charge.dockFailed': "Не удалось встать на зарядку (этап: {stage})",
  'charge.dockTried': "пробовал: {list}",
  'fleet.chargeShort': 'Зарядка',
  'charge.dockTitleMany': "Едет к ближайшей свободной ⚡ зарядке (на карте: {n}), затем стыкуется со станцией",
  'charge.occ.free': "свободна",
  'charge.occ.occupied': "занята",
  'charge.occ.occupiedBy': "занята: {name}",
  'charge.occ.reserved': "зарезервирована",
  'charge.occ.reservedBy': "резерв: {name}",
  'charge.occ.unknown': "состояние неизвестно",
  'charge.occ.thisRobot': "этот робот",
  'charge.countOnMap': "Зарядок на карте: {n}",
  'charge.showOnMap': "Показать на карте",
  'charge.chooseCharger': "Выбрать зарядку",
  'charge.nearestFree': "Ближайшая свободная",
  'charge.dockNearest': "На зарядку · ближайшая свободная",
  'charge.noChargersShort': "На этой карте нет точек ⚡ зарядки",
  'charge.chargersTitle': "Зарядки",
  'charge.addCharger': "Точка зарядки",
  'charge.chargerIs': "Зарядка:",
  'charge.edit': "Изменить",
  'charge.newName': "Зарядка",
  'charge.clickHint': "Кликните на карте ~0.5 м перед зарядной станцией, затем поверните стрелку к станции",
  'drive.keysHint': "W A S D / стрелки · W+D = плавный поворот",
  'drive.fwdLeftAria': "Вперёд и влево (дуга)",
  'drive.fwdRightAria': "Вперёд и вправо (дуга)",
  'drive.backLeftAria': "Назад и влево (дуга)",
  'drive.backRightAria': "Назад и вправо (дуга)",
  'hand.button': "Ручной режим",
  'hand.title': "Отпустить тормоза колёс, чтобы сотрудник мог передвинуть робота",
  'hand.lock': "Заблокировать колёса",
  'guard.title': "Охрана робота",
  'guard.short': "Охрана",
  'guard.off': "Охрана выключена",
  'guard.turnOn': "Включить охрану",
  'guard.turnOff': "Выключить охрану",
  'guard.distance': "Дистанция охраны",
  'guard.distanceHint': "0,5–3,0 м: при пересечении — предупреждение голосом, через секунду — сирена",
  'guard.closer': "Ближе",
  'guard.farther': "Дальше",
  'guard.pause': "Пауза 15 мин",
  'guard.resume': "Возобновить",
  'guard.reset': "Сброс на 1,5 м",
  'guard.hint': "Применяется сразу; каждое изменение записывается в журнал робота.",
  'guard.lidarOk': "лидар работает",
  'guard.lidarNo': "нет данных лидара",
  'guard.ros': "ROS подключён",
  'guard.rosDown': "ROS не подключён",
  'guard.state.watching': "Следит",
  'guard.state.learning': "изучает обстановку",
  'guard.state.moving': "Едет — лидар ждёт, касания рук отслеживаются",
  'guard.state.warn': "Предупреждение",
  'guard.state.alarm': "ТРЕВОГА",
  'guard.state.touch': "Касание рук",
  'guard.state.paused': "Пауза до {until}",
  'guard.state.blind': "Не видит (нет данных лидара)",
  'guard.fail': "Охрана · {name}: {why}",
  'guard.failSilent': "Охрана · {name} не ответил",
  'guard.whyUnsupported': "приложение робота без охраны — обновите APK",
  'hand.lockTitle': "Снова включить тормоза колёс",
  'hand.banner': "Режим ручного перемещения — колёса отпущены.",
  'hand.driveHint': "Включён ручной режим — управление отключено, пока колёса не заблокированы. STOP тоже блокирует их.",
  'hand.blocked': "включён ручной режим — сначала заблокируйте колёса",
  'auto.home.toPoint': "Возвращается на своё место ({point})",
  'auto.home.back': "Возвращается на своё место",
  'auto.home.idle': "нет активности {s} с",
  'auto.home.idleNoS': "нет активности",
  'auto.tabTranscript': "Транскрипт",
  'auto.tabControls': "Управление",
  'auto.liveControls': "Управление на ходу",
  'auto.sessionNow': "Этот сеанс",
  'auto.controlsNote': "Изменения не ставят автономию на паузу",
  'auto.maxSpeedSession': "Макс. скорость",
  'auto.turnSpeed': "Скорость поворота",
  'auto.turnSpeedTip': "Как быстро робот поворачивается. Он разворачивается на месте, поэтому радиуса поворота нет.",
  'auto.sessionLang': "Язык",
  'auto.paramsApiMissing': "Для изменения во время автономии нужен более новый сервер",
  'charge.title': "Автозарядка",
  'charge.enabled': "Автозарядка включена",
  'charge.low': "Ехать заряжаться ниже",
  'charge.resume': "Продолжить при",
  'charge.critical': "Критический",
  'charge.criticalHint': "На этом уровне робот бросает всё и сразу едет на зарядку",
  'charge.resumeTask': "Продолжить задачу после зарядки",
  'charge.save': "Сохранить автозарядку",
  'charge.saved': "Настройки автозарядки сохранены",
  'charge.saveFailed': "Не удалось сохранить настройки автозарядки",
  'charge.apiMissing': "Для автозарядки нужен более новый сервер",
  'charge.noCharger': "На карте «{map}» нет точки ⚡ зарядки — робот будет стыковаться со станцией напрямую, без подъезда по точке.",
  'charge.openMap': "Указать на карте",
  'charge.state.idle': "ожидание",
  'charge.state.going': "едет на зарядку",
  'charge.state.charging': "заряжается",
  'charge.state.failed': "ошибка",
  'charge.lowToast': "Батарея {b}% — едет на зарядку",
  'charge.dockedToast': "на зарядке ({b}%)",
  'charge.failedToast': "Не смог доехать до зарядки",
  'charge.resumedToast': "заряжен до {b}% — продолжает задачу",
  'charge.chip.going': "Едет заряжаться",
  'charge.chip.charging': "Заряжается",
  'charge.chip.failed': "Не доехал до зарядки",
  'charge.dockTitle': "На зарядку: если на карте задана точка ⚡ зарядки — едет к ней, затем стыкуется со станцией",
  'charge.dockTitleCharger': "Едет к точке ⚡ зарядки «{name}», затем стыкуется со станцией",
  'charge.dockTitleNoCharger': "На этой карте нет точки ⚡ зарядки — стыкуется со станцией напрямую",
  'charge.pointType': "Тип точки",
  'charge.kindNormal': "Обычная",
  'charge.kindCharger': "Зарядка",
  'charge.kindTaken': "перенесётся с другой точки",
  'charge.moveChargerConfirm': "«{from}» уже точка ⚡ зарядки (на карте только одна). Перенести ⚡ на «{to}»?",
  'charge.placeHint': "Поставьте точку ~0.5 м перед зарядной станцией, стрелкой к станции",
  'charge.rotateHandle': "Потяните, чтобы задать направление (Shift — без шага)",
  'stuck.phase.detour': "объезжает",
  'stuck.phase.detour.left': "объезжает слева",
  'stuck.phase.detour.right': "объезжает справа",
  'stuck.phase.detected': "обнаружено препятствие",
  'stuck.phase.announce': "просит освободить проход",
  'stuck.phase.lookaround': "осматривается",
  'stuck.phase.replan': "ищет другой путь",
  'stuck.phase.recovered': "путь свободен",
  'stuck.phase.failed': "не удалось",
  'stuck.banner': "Заблокирован — {phase} (попытка {a}/{m})",
  'stuck.failed': "Робот не может проехать — нужна помощь",
  'stuck.failedAt': "в точке x {x} · y {y}",
  'stuck.goal': "ехал к {goal}",
  'stuck.showOnMap': "Показать на карте",
  'stuck.dismiss': "Скрыть",
  'stuck.recoveredToast': "{name}: путь свободен, продолжаю",
  'stuck.failedToast': "{name} не может проехать — нужна помощь",
  'stuck.openRobot': "Открыть робота",
  'stuck.chip': "Заблокирован {a}/{m}",
  'stuck.chipFailed': "Застрял — помощь",
  'stuck.line': "⚠ Заблокирован — {phase} ({a}/{m})",
  'stuck.lineRecovered': "✓ Путь свободен",
  'stuck.lineFailed': "⛔ Не может проехать — сдался после {a} попыт.",
  'stuck.pointBadge': "застревал ×{n}",
  'stuck.pointBadgeTitle': "Робот недавно застревал по пути к этой точке: {n} раз",
  'reach.tight': "Слишком близко к стене — робот подъедет к ближайшей доступной точке",
  'reach.unreachable': "Недостижима: закрыта виртуальными стенами / препятствиями",
  'reach.status.ok': "Достижима",
  'reach.status.tight': "Слишком близко к стене",
  'reach.status.enclosed': "Закрыта виртуальными стенами",
  'reach.status.blocked': "Закрыта препятствиями",
  'reach.countUnreachable': "{n} недостижимы",
  'reach.countTight': "{n} у стены",
  'reach.moveHere': "Переместить точку сюда",
  'reach.clearance': "зазор {m} м",
  'reach.pending': "Достижимость проверится после сохранения",
  'reach.approach': "Ближайшая доступная точка",
  'reach.noApproach': "Рядом нет доступной точки — переместите точку или измените стены",
  'reach.warnUnreachable': "Недостижимых точек: {n}",
  'reach.warnTight': "Точек у стены: {n}",
  'reach.savedWarnings': "Сохранено с предупреждениями: {s}",
  'auto.bargeHint': 'Отправка прервёт робота',
  'auto.interrupted': 'прервано',
  // §6.2 real walls (scan editor) — copy from the approved artboard
  'scan.modeAria': "Какие стены",
  'scan.modeVirtual': "Виртуальные · {n}",
  'scan.modeScan': "Реальные (скан)",
  'scan.title': "Реальные стены",
  'scan.revision': "версия {n}",
  'scan.editedByHand': "изменено вручную",
  'scan.originalScan': "исходный скан",
  'scan.modifiedTag': "Скан изменён вручную",
  'scan.help': "Робот прокладывает путь по отсканированной карте.",
  'scan.helpPencil': "{b} дорисуйте то, чего не видит лазер: стекло, проёмы, ограждения.",
  'scan.helpPencilB': "Карандашом",
  'scan.helpEraser': "{b} сотрите мусор скана: людей, стулья, коробки.",
  'scan.helpEraserB': "Ластиком",
  'scan.warn': "Настоящие стены не стирайте: по ним робот понимает, где находится. Нарисованную стену лазер не видит — она только запрещает путь.",
  'scan.hand': "Рука",
  'scan.pencil': "Карандаш",
  'scan.pencilSub': "Дорисовать стену",
  'scan.eraser': "Ластик",
  'scan.eraserSub': "Стереть мусор",
  'scan.toolbar': "Инструменты редактирования скана",
  'scan.width': "Толщина",
  'scan.cm': "{n} см",
  'scan.m': "{n} м",
  'scan.undo': "Отменить",
  'scan.redo': "Повторить",
  'scan.original': "Исходный скан",
  'scan.originalTitle': "Показать исходный скан без правок",
  'scan.originalPill': "Исходный скан · правки скрыты",
  'scan.originalFailed': "Исходный скан недоступен",
  'scan.showOriginal': "Показать исходный скан (без правок)",
  'scan.hintPencil': "Карандаш: ведите мышью по карте — рисуется стена · Shift — прямая линия · Ctrl/⌘+Z — отменить · колёсико — масштаб",
  'scan.hintEraser': "Ластик: ведите мышью — стирает препятствия скана (люди, стулья, коробки) · Ctrl/⌘+Z — отменить · колёсико — масштаб",
  'scan.hintPan': "Рука: перетаскивайте карту, колёсико — масштаб · пробел — временно рука в любом инструменте",
  'scan.legend': "Обозначения",
  'scan.legendWall': "Новая стена · не сохранено",
  'scan.legendErase': "Стёрто · не сохранено",
  'scan.legendVirtual': "Виртуальная стена (не меняется здесь)",
  'scan.pending': "Несохранённые правки: {n}",
  'scan.statWall': "+ {m} м стены",
  'scan.statErase': "стёрто {m} м²",
  'scan.reset': "Вернуть исходный скан",
  'scan.resetHelp': "Удалит все сохранённые правки скана этой карты. Виртуальные стены и точки не тронет.",
  'scan.resetConfirm': "Вернуть исходный скан? Все сохранённые правки скана этой карты будут удалены. Виртуальные стены и точки останутся как есть.",
  'scan.resetConfirmPending': "Несохранённые правки ({n}) тоже пропадут.",
  'scan.resetDone': "Исходный скан восстановлен",
  'scan.resetFailed': "Не удалось вернуть исходный скан",
  'scan.save': "Сохранить карту *",
  'scan.saving': "Сохраняю…",
  'scan.noChanges': "Нет изменений",
  'scan.savedButton': "Карта сохранена",
  'scan.savedNotice': "Карта сохранена · версия {n}",
  'scan.outdatedOne': "{name} ездит по старой версии. Разверните карту, чтобы робот получил правки.",
  'scan.outdatedMany': "{list} ездят по старой версии. Разверните карту, чтобы роботы получили правки.",
  'scan.noOutdated': "Эта карта ещё не установлена ни на одного робота.",
  'scan.deploy': "Развернуть на роботов",
  'scan.dismiss': "Скрыть",
  'scan.savedToast': "Карта сохранена — разверните её на роботов, чтобы применить правки",
  'scan.saveFailed': "Не удалось сохранить карту",
  'scan.saveError': "Не удалось сохранить карту: {reason}. Правки остались на экране — попробуйте ещё раз.",
  'scan.noResponse': "сервер не ответил",
  'scan.apiMissing': "Редактирование скана пока недоступно на этом сервере (нет эндпоинтов PROTOCOL §6.2). Правки останутся здесь, пока вы не уйдёте со страницы.",
  'scan.limit': "Слишком много правок скана на этой карте: всего не больше {strokes} штрихов и {coords} координат.",
  'scan.switchConfirm': "Несохранённые правки скана ({n}) пропадут. Всё равно переключиться?",
  'scan.saveBeforeDeploy': "В скане есть несохранённые правки. Сохранить их перед развёртыванием?",
  // §6.3 «Что мешает доехать» — copy from the approved artboard
  'access.tab': "Доступность",
  'access.badge': "Недоступны: {n}",
  'access.heading.one': "{n} точка недоступна",
  'access.heading.few': "{n} точки недоступны",
  'access.heading.many': "{n} точек недоступны",
  'access.allOk': "Все точки доступны",
  'access.help': "Роботу нужен проход не уже {w} м: по {c} м от стен с каждой стороны. Ниже — что именно перекрывает путь, начиная с того, что мешает больше всего.",
  'access.showOnMap': "Показывать на карте",
  'access.chip': "Что мешает доехать",
  'access.narrow': "Узкий проход",
  'access.narrowAt': "Узкий проход у «{name}»",
  'access.narrowZone': "Узкий проход в зону «{name}»",
  'access.narrowTo': "Узкий проход к «{name}»",
  'access.narrowToMore': "Узкий проход к «{name}» и ещё {n}",
  'access.realTo': "Стена скана на пути к «{name}»",
  'access.realToMore': "Стена скана на пути к «{name}» и ещё {n}",
  'access.virtual': "Виртуальная стена №{n}",
  'access.real': "Стена скана",
  'access.realAt': "Стена скана у «{name}»",
  'access.blocks.one': "мешает {n} точке",
  'access.blocks.few': "мешает {n} точкам",
  'access.blocks.many': "мешает {n} точкам",
  'access.passage': "проход ≈ {w} м",
  'access.kindVirtual': "виртуальная стена",
  'access.kindReal': "стена скана",
  'access.helpNarrow': "Между стенами скана меньше {w} м. Если в проходе мусор скана (люди, стулья) — сотрите его ластиком. Если проход настоящий, робот туда не проедет.",
  'access.helpVirtual': "Робот никогда не пересекает виртуальные стены. Уберите или сдвиньте её, если сюда можно ездить.",
  'access.helpReal': "Путь перекрывает стена скана. Если это не настоящая стена (дверь была закрыта при сканировании, мусор), сотрите её ластиком.",
  'access.pointsList': "Точки: {list}",
  'access.show': "Показать на карте",
  'access.fixErase': "Открыть ластик здесь",
  'access.fixWall': "Изменить стену",
  'access.computing': "Считаю…",
  'access.noBlockers': "Сервер не смог определить, что именно им мешает.",
  'access.apiMissing': "Этот сервер пока не умеет искать, что мешает доехать (нет эндпоинта PROTOCOL §6.3). Недоступные точки всё равно отмечены на карте.",
  'access.loadFailed': "Не удалось загрузить, что мешает: {msg}",
  'access.markerVirtual': "№{k} · {n}",
  'access.markerReal': "Стена скана · {n}",
  'access.passageVV': "проход ≈ {w} м между виртуальными стенами №{a} и №{b}",
  'access.passageRV': "проход ≈ {w} м между стеной скана и виртуальной стеной №{a}",
  'access.passageV1': "проход ≈ {w} м между частями виртуальной стены №{a}",
  'access.passageRR': "проход ≈ {w} м между стенами скана",
  'access.fixWallN': "Изменить стену №{n}",
  'access.helpNarrowVirtual': "Раздвиньте эти стены, чтобы проход стал не уже {w} м.",
  'access.helpNarrowOneWall': "Измените виртуальную стену №{n}, чтобы проход стал не уже {w} м.",
  'access.helpNarrowMixed': "Отодвиньте виртуальную стену №{n} от стены скана, чтобы проход стал не уже {w} м. Если стена скана — мусор (люди, стулья), сотрите её ластиком.",
  'access.legend': "Обозначения",
  'access.legendNarrow': "Узкий проход: уже {w} м",
  'access.legendWall': "Виртуальная стена на пути",
  'access.legendPath': "Куда робот не может проехать",
  'access.legendPoint': "Недоступная точка",
  'maps.saving': "Сохраняю…",
  // bulk «переставить точки от стен» (вкладка Точки) — copy from the approved board
  'bulk.hintTitle': "Точек слишком близко к стене: {n}",
  'bulk.hintText': "Робот не встаёт на такую точку и останавливается рядом. Переставьте их на рекомендуемые места — в {m} м от стены.",
  'bulk.hintButton': "Переставить все на рекомендуемые места…",
  'bulk.hintHide': "Скрыть подсказку",
  'bulk.linkTitle': "Переставить на рекомендуемые места",
  'bulk.pointLink': "Переставить все такие точки ({n})…",
  'bulk.toastAction': "Переставить ({n})",
  'bulk.back': "Точки",
  'bulk.title': "Переставить точки от стен",
  'bulk.text': "Каждая точка встанет в ближайшее место, где до стены не меньше {m} м, — туда робот доедет и встанет точно. Дальше 1 м и через стену точка не сдвинется.",
  'bulk.selected': "Выбрано: {on} из {all}",
  'bulk.shift': "сдвиг {a}–{b} м",
  'bulk.turn': "Повернуть к старому месту — к экспонату",
  'bulk.turnHint': "Только точкам без направления ({n}). Заданное направление не меняется.",
  'bulk.all': "Все",
  'bulk.sortHint': "по сдвигу ↓ · клик — показать на карте",
  'bulk.row': "зазор {c} м → сдвиг {s} м",
  'bulk.rowAria': "Переставить {n} · {name}",
  'bulk.enclosedNote': "Точки за виртуальными стенами так не исправить — для них вкладка «Доступность».",
  'bulk.cancel': "Отмена",
  'bulk.apply': "Переставить и сохранить · {n}",
  'bulk.empty': "Точек у стен нет",
  'bulk.previewChip': "Предпросмотр — точки ещё на старых местах",
  'bulk.legend': "Обозначения",
  'bulk.legendNow': "Точка сейчас — слишком близко к стене",
  'bulk.legendSpot': "Рекомендуемое место ({m} м от стены)",
  'bulk.legendFace': "Куда робот повернётся (к старому месту)",
  'bulk.doneTitle': "Переставлено и сохранено точек: {n}",
  'bulk.doneAllOk': "Все точки доступны.",
  'bulk.doneLeft': "Ещё у стены: {n}.",
  'bulk.doneFacing': "Каждая повёрнута к своему старому месту — к экспонату.",
  'bulk.undo': "Вернуть как было",
  'bulk.hide': "Скрыть",
  'bulk.doneToast': "Переставлено и сохранено точек: {n}",
  'bulk.toastUndo': "Отменить",
  'bulk.undone': "Вернул на старые места точек: {n}",
  'bulk.undoSkipped': "Не тронуты (вы их уже изменили): {k}",
  'maps.allPoints': 'Все точки',
  'maps.pointPos': '{i} из {n}',
  'maps.prevPoint': 'Предыдущая точка',
  'maps.nextPoint': 'Следующая точка',
  'maps.filterAll': 'Все · {n}',
  'maps.filterLabel': 'Фильтр точек',
  'charge.addShort': 'Зарядка',
  'tours.allTours': 'Все туры',
  'tours.tabStops': 'Остановки · {n}',
  'tours.tabSettings': 'Настройки',
  'tours.tabRobots': 'Роботы · {n}',
  'tours.findStop': 'Найти остановку',
  'tours.addStopShort': '+ Остановка',
  'tours.noStops': 'Остановок пока нет: добавьте точки кнопкой «+ Остановка».',
  'tours.stopSettings': 'Настройки остановки: {name}',
  'tours.toursCount': '{n} на этой карте',
  'facing.bulkTitle': 'Задать направление всем {n} точкам без него',
  'facing.bulkPresets': 'Быстрый выбор',
  'facing.bulkHint': 'Точки, у которых направление уже есть, не меняются. На карте видно сразу, сохраняется кнопкой «Сохранить точки».',
  'facing.bulkApply': 'Повернуть {n} точек',
  'facing.bulkDone': '{n} точек повернуты на {deg}°. Не забудьте сохранить точки.',
  'nav.updates': 'Обновления',
  'upd.title': 'Обновления приложения робота',
  'upd.auto': 'Автообновление роботов',
  'upd.new': 'Новая версия',
  'upd.drop': 'Перетащите сюда APK робота',
  'upd.choose': 'Выбрать файл',
  'upd.other': 'Другой файл',
  'upd.uploading': 'Загрузка и проверка… {pct}%',
  'upd.checked': '{size} · проверен',
  'upd.version': 'Версия',
  'upd.codeOf': 'код {code} (на роботах {fleet})',
  'upd.signature': 'Подпись',
  'upd.sigSame': 'совпадает с текущей',
  'upd.sigUnknown': 'не проверена',
  'upd.notes': 'Что нового (видно в списке версий)',
  'upd.to': 'Кому',
  'upd.toAll': 'Все роботы · {n}',
  'upd.toSite': 'Площадка',
  'upd.toRobots': 'Выбрать роботов…',
  'upd.toRobotsN': 'Роботы · {n}',
  'upd.pickTitle': 'Выбор роботов',
  'upd.done': 'Готово',
  'upd.idleOnly': 'Только в простое',
  'upd.idleOnlyHint': '— не во время тура, поездки, тревоги охраны и разговора',
  'upd.canary': 'Сначала один робот',
  'upd.canaryHint': 'остальные — после того, как он вышел на связь с новой версией',
  'upd.publish': 'Выпустить {v}',
  'upd.published': 'Версия {v} выпущена',
  'upd.versions': 'Версии',
  'upd.noVersions': 'Загруженных версий пока нет',
  'upd.onRobots': 'на роботах: {n}',
  'upd.rollingOut': 'выпускается · {done}/{total}',
  'upd.notPublished': 'не выпущена',
  'upd.delete': 'Удалить',
  'upd.deleteConfirm': 'Удалить версию {v}?',
  'upd.rollout': 'Выпуск {v}',
  'upd.progress': '{done} из {total} обновлены',
  'upd.progressTap': 'ждут нажатия: {n}',
  'upd.pause': 'Приостановить выпуск',
  'upd.resume': 'Продолжить выпуск',
  'upd.pausedTag': 'приостановлен',
  'upd.noRollout': 'Сейчас ничего не выпускается. Загрузите APK и нажмите «Выпустить».',
  'upd.fAll': 'Все · {n}',
  'upd.fIdle': 'Ждут простоя · {n}',
  'upd.fTap': 'Ждут нажатия · {n}',
  'upd.fProblems': 'Проблемы · {n}',
  'upd.fOffline': 'Офлайн · {n}',
  'upd.colRobot': 'Робот',
  'upd.colSite': 'Площадка',
  'upd.colVersion': 'Версия',
  'upd.colState': 'Состояние',
  'upd.s.done': 'Обновлён',
  'upd.s.canary': 'пробный робот',
  'upd.s.offline': 'Офлайн · обновится при подключении',
  'upd.s.manual': 'Старое приложение без автообновления',
  'upd.s.manualHint': 'один раз поставьте эту версию вручную',
  'upd.s.paused': 'Выпуск приостановлен',
  'upd.s.waiting_canary': 'Ждёт пробного робота',
  'upd.s.pending': 'Предложение отправлено',
  'upd.s.downloading': 'Скачивает',
  'upd.s.failed': 'Ошибка',
  'upd.s.unknown_sources': 'Неизвестные источники выключены',
  'upd.s.unknownHint': 'один раз: Настройки → Безопасность → включить',
  'upd.s.waiting_idle': 'Ждёт простоя',
  'upd.s.snoozed': 'Скачано · нажали «Позже»',
  'upd.s.prompt': 'Ждёт нажатия на роботе',
  'upd.s.promptAt': 'плашка «Установить» показана в {time}',
  'upd.s.installer': 'Открыто окно установки Android',
  'upd.s.installerHint': 'нажмите там «Установить»',
  'upd.busy.tour': 'идёт тур «{name}» · точка {step} из {total}',
  'upd.busy.tourShort': 'идёт тур',
  'upd.busy.moving': 'робот едет',
  'upd.busy.talking': 'разговаривает с посетителем',
  'upd.busy.media': 'показывает медиа',
  'upd.busy.guard': 'тревога охраны',
  'upd.showNow': 'Показать сейчас',
  'upd.showAgain': 'Показать снова',
  'upd.retry': 'Повторить',
  'upd.footer': 'Роботы узнают о выпуске сразу и скачивают файл сами, сверяя контрольную сумму. Установку подтверждает человек на экране робота: «Установить», затем «Установить» в окне Android. Вернуть старую версию можно только сборкой с бо́льшим кодом версии.',
  'upd.err.NOT_APK': 'Это не APK',
  'upd.err.NOT_APKHint': 'В файле нет AndroidManifest.xml.',
  'upd.err.NOT_NEWER': 'Версия не новее',
  'upd.err.NOT_NEWERHint': 'В файле код {code}, а на роботах уже {fleet}. Увеличьте versionCode и соберите заново.',
  'upd.err.CERT_MISMATCH': 'Другая подпись',
  'upd.err.CERT_MISMATCHHint': 'Android не поставит этот файл поверх установленного. Соберите тем же ключом, что и прошлые версии.',
  'upd.err.WRONG_PACKAGE': 'Не приложение робота',
  'upd.err.WRONG_PACKAGEHint': 'Это {package}. Нужен {expected}.',
  'upd.chip.version': 'App {v}',
  'upd.chip.available': 'есть {v}',
  'upd.chip.downloading': 'Скачивает {pct}%',
  'upd.chip.waitingIdle': 'Ждёт простоя',
  'upd.chip.tap': 'Ждёт нажатия на роботе',
  'upd.chip.unknownSources': 'Неизвестные источники выкл.',
  'upd.chip.failed': 'Ошибка обновления',
};
